import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";

@Component({
  selector: "modal-singleorder",
  templateUrl: "./singleorder.html"
})
export class SingleOrderModal {
  public order: any;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    console.log(this.order);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/ordersdispatched/singleordermodal.ts